/* eslint-disable lit-a11y/mouse-events-have-key-events */
import { html } from 'lit-element';
import AabSelectOption from './AabSelectOption';

/**
 * For WAI ARIA guidelines on roles, states, aria-attributes, etc., see:
 * https://www.w3.org/TR/wai-aria-practices-1.1/examples/listbox/listbox-collapsible.html
 *
 * @param {string} arg0.value the value of the AabSelect
 * @param {boolean} arg0.hasLabel whether or not the AabSelect has a label passed to it
 * @param {number} arg0.focusedOptionIndex the index of the 'focused' option
 * @param {boolean} arg0.isOpen whether the dropdown is open or not (i.e., visible or collapsed)
 * @param {string} arg0.width the width of the dropdown. Can be either fixed to the size of the button ('fixed'), or determined by its contents ('auto')
 * @param {string} arg0.align the horizonal alignment of the dropdown. For when the dropdown has a different size than it's AabSelect. 'left' or 'right'
 * @param {Array<Option>} arg0.options the options of the AabSelect
 * @param {function} arg0.onMouseOut a callback for when a mouseover event occurs on the dropdown
 * @param {function} arg0.onOptionClick a callback for when a click event occurs on one of the options
 * @param {function} arg0.onOptionMouseOver a callback for when a mouseover event occurs on one of the options
 */
export default ({
  value,
  hasLabel,
  focusedOptionIndex,
  isOpen,
  width,
  align,
  options,
  onMouseOut,
  onOptionClick,
  onOptionMouseOver,
}) => html` <ul
  tabindex="-1"
  role="listbox"
  aria-labelledby="${hasLabel ? 'aab-select-label' : ''}"
  aria-label="${!hasLabel ? 'Dropdown' : ''}"
  aria-activedescendant="${focusedOptionIndex > -1
    ? `aab-option-${focusedOptionIndex}`
    : undefined}"
  class=${`dropdown ${isOpen ? 'd-block' : ''} ${
    align === 'right'
      ? 'dropdown--align-right'
      : 'dropdown--align-left'
  } ${width === 'fixed' ? 'dropdown--width-full' : 'dropdown--width-auto'}`}
  @mouseout=${onMouseOut}
>
  ${options.map(
    (option, index) => AabSelectOption({
      id: `aab-option-${index}`,
      isSelected: option.value === value,
      isFocused: index === focusedOptionIndex,
      disabled: option.disabled,
      name: option.name,
      icon: option.icon,
      onClick: onOptionClick,
      onMouseOver: () => onOptionMouseOver(index),
    }),
  )}
</ul>`;
